import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import en from './locales/en.json';
import hi from './locales/hi.json';
import ta from './locales/ta.json';

// Get saved language from localStorage or default to English
const savedLanguage = localStorage.getItem('fitT-language') || 'en';

const resources = {
  en: {
    translation: en
  },
  hi: {
    translation: hi
  },
  ta: {
    translation: ta
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: savedLanguage, // language to use
    fallbackLng: 'en', // fallback language
    
    interpolation: {
      escapeValue: false // react already does escaping
    },
    
    // Configure namespace
    defaultNS: 'translation',
    ns: ['translation'],
    
    // Configure detection options
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

// Save language preference when it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('fitT-language', lng);
});

export default i18n;